<template>
  <el-dialog title="添加客户" width="550px" append-to-body destroy-on-close :modal="false" center :visible.sync="dialogFormVisible" :close-on-click-modal="false" @close="$emit('input',false)">
    <el-form ref="clueForm" :model="form" :rules="rules" label-width="80px" label-position="top" style="padding: 0 16px;">
      <el-row style="margin-bottom: 10px;" :gutter="20">
        <el-col :span="12">
          <el-form-item prop="client_name" label="客户简称">
            <el-input class="form-select" v-model.trim="form.client_name" placeholder="请输入客户简称" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="secondary_dept" label="所属组别">
<!--            ClueOption-->
            <el-select filterable class="form-select" filterable v-model="form.secondary_dept" placeholder="请选择所属组别">
              <el-option v-for="item in ClueOption.dept" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row style="margin-bottom: 10px;" :gutter="20">
        <el-col :span="12">
          <el-form-item prop="client_fullname" label="客户全称">
            <el-input class="form-select" v-model.trim="form.client_fullname" placeholder="请输入客户全称" />

          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="client_manager" label="所属客户经理">
            <el-select filterable class="form-select" filterable v-model="form.client_manager" placeholder="请选择所属客户经理">
              <el-option v-for="item in ClueOption.client_manager" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>


      <el-form-item style="display: flex;justify-content: end;">
        <el-button :loading="loading" type="primary" @click="onSubmit('clueForm')">确定</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import CustomCardTable from "@/component/PrePayManage/dialog/CustomCardTable";
import CustomTool from "@/component/Performance/topTool/CustomTool";
import {addClient, addClue, exportExcel, exportPerformanceDetail, exportProjectDetail, getClueOption} from "@/api/api";
import {quotation_type} from "@/config";
export default {
  name: "addClientDialog",
  components:{
  },
  props:{
    value:{
      type: Boolean,
      default:false,
      required: true
    },
    clueForm:{
      type:Object
    },
    ClueOption:{
      type:Object
    },
    client_manager_options:{
      type:Array
    },
    client_name:{
      type:String
    }
  },
  data() {
    return {
      loading:false,
      dialogFormVisible: false,
      refreshId:0,
      form: {
        "client_name": "",
        "client_fullname": "",
        "client_manager": "",
        "secondary_dept": ""
      },
      rules: {
        client_name: [
          { required: true, message: '请输入客户简称', trigger: 'blur' }
        ],
        secondary_dept: [
          { required: true, message: '请输入所属组别', trigger: 'blur' }
        ],
        client_fullname: [
          { required: true, message: '请输入客户全称', trigger: 'blur' }
        ],
        client_manager: [
          { required: true, message: '请选择所属客户经理', trigger: 'change' }
        ]
      }
    }
  },

  watch:{
    value(newVal){
      this.dialogFormVisible = newVal
      if(this.dialogFormVisible){
        this.refresh()
      }
    },
    client_name(newVal){
      this.form.client_name = newVal
    },
    clueForm(newVal){
      Object.assign(this.form,newVal)
    }
  },
  mounted() {
    Object.assign(this.form,this.clueForm)
    this.form.client_name = this.client_name

    // this.quotation_type = quotation_type
    // this.getClientNameList()
  },
  methods:{
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log('submit!',this.form);
          this.addClientAction()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    async addClientAction(){
      let res = await addClient(this.form)
      if(res.respCode&&res.respCode=='000000'){
        console.log('addClientAction',res)
        this.$message.success(res.respMsg)
        this.$store.commit("setUpdateClientList")
        this.$nextTick(()=>{
          this.loading = false
          this.$emit('input',false)
        })
      }else{
        this.$message.error(res.respMsg)
      }
    },

    refresh(content){
      this.refreshId +=1
    }
  }
}
</script>

<style scoped>

/deep/ .form-select.el-select{
  width: 100%;
}

/deep/ .el-dialog {
  display: flex;
  flex-direction: column;
  margin:0 !important;
  position:absolute;
  top:50%;
  left:50%;
  transform:translate(-50%,-50%);
  /*height:600px;*/
  max-height:calc(100% - 200px);
  max-width:calc(100% - 30px);
}
/deep/ .el-dialog .el-dialog__body {
  flex:1;
  overflow: auto;
}

</style>
